var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"instagram-btn transition",attrs:{"noprint":""}},[_c('a',{staticClass:"instagram-btn-buttom",attrs:{"target":"_blank","href":"https://instagram.com/models1a.agency?igshid=YmMyMTA2M2Y="}},[_c('img',{staticClass:"instagram-btn-img",attrs:{"src":require("../../assets/img/instagram_75x75.png"),"alt":"Boton redireccion a Instagram"}})])])
}]

export { render, staticRenderFns }